export const SUPPORTED_LOCALES = [
	'en',
	'de',
	'es',
	'fr',
	'it',
	'pt',
	'ar',
	'ro',
	'ru',
	'nl',
	'no',
	'tr',
	'hu'
] as const

export type Locale = (typeof SUPPORTED_LOCALES)[number]
